import './account-menu.css';
import { mountTemplate } from './modal-base';
import { t } from '../../i18n';
import { mountLangSwitcher } from '../lang-switcher';

function buildAccountMenuTemplate(): string {
  return /* html */ `
<div class="modal-overlay" id="account-menu-modal">
  <div class="modal-content">
    <h3 style="margin-top:0;">${t('account.title')}</h3>
    <p id="account-menu-email" class="account-email"></p>
    <div class="account-actions">
      <button class="modal-btn" onclick="openMyHeadstones()">${t('account.myTombs')}</button>
      <button class="secondary-modal-btn" onclick="openCommunityMemories()">${t('account.communityMemories')}</button>
      <button class="secondary-modal-btn" onclick="logoutCurrentUser()">${t('account.logout')}</button>
      <div class="account-lang-wrap" id="account-lang-wrap"></div>
      <button onclick="closeAccountMenuModal()" class="text-link-btn" style="margin-top:0;">${t('account.close')}</button>
    </div>
  </div>
</div>
`;
}

export function mountAccountMenuModal(): void {
  mountTemplate('account-menu-modal', buildAccountMenuTemplate());
  const wrap = document.getElementById('account-lang-wrap');
  if (wrap) mountLangSwitcher(wrap);
}

export function remountAccountMenuModal(): void {
  mountAccountMenuModal();
}
